import moment from 'moment'
import { useContext } from 'react'

import GenericTable, {
  DataTableInterface,
} from '../../../../components/misc/GenericTable'
import { CurrenciesPaymentInterface } from '../../../../interfaces/ServerInterfaces'
import { formatCurrency, formatDate } from '../../../../utils/helpers'
import { translatePaymetMethods } from '../../../../utils/translate'
import { RegisterDetailsContext } from '../RegisterDetailsContainer'

export const PartialPaysDetailsTab = () => {
  const { order } = useContext(RegisterDetailsContext)

  const partialPaymentsList: CurrenciesPaymentInterface[] =
    order?.partialPayments?.map((item) => item) ?? []
  const tableTitles = [
    'No. de pago',
    'Registro de caja',
    'Método de pago',
    'Importe',
    'Fecha',
    'Observaciones',
  ]

  const tableData: DataTableInterface[] = []
  partialPaymentsList.map((item, i) => {
    const newRow: DataTableInterface = {
      rowId: item.id,
      payload: {
        'No. de pago': partialPaymentsList.length - i,
        'Método de pago': translatePaymetMethods(item?.paymentWay),
        Importe: formatCurrency(item?.amount, item?.codeCurrency),
        Fecha: formatDate(item?.createdAt),
        Observaciones: <p className="text-center">{item?.observations}</p>,
      },
    }

    if (item?.cashRegisterOperations?.length > 0) {
      if (item?.cashRegisterOperations[0]?.paymentDateClient) {
        newRow.payload['Fecha de pago del cliente'] = formatDate(
          item.cashRegisterOperations[0]?.paymentDateClient
        )
      }
      if (item?.cashRegisterOperations[0]?.operationNumber) {
        newRow.payload['Registro de caja'] = `RC-${moment(
          item.createdAt
        ).year()}/${item.cashRegisterOperations[0]?.operationNumber}`
      }
    }

    tableData.push(newRow)
  })

  return (
    <div className="h-[26rem] px-3">
      <GenericTable tableData={tableData} tableTitles={tableTitles} />
    </div>
  )
}
